import { faTrashCan } from "@fortawesome/pro-duotone-svg-icons";
import { isAdmin as isAdminSignal, userData } from "../Common/Store/CommonSignals";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function DeleteButton({ component, onClick, data, name }) {
  const userRolePerms = userData.value?.permissions;
  const userIsAdmin = isAdminSignal.value;
  const userEmail = userData.value?.userEmail;

  return (
    <ColorChangingIcon
      icon={faTrashCan}
      name={name}
      initialPrimaryColor="#6e6e6e"
      initialSecondaryColor="#919191"
      initialSize={18}
      hoverSize={18}
      padding="0 2px 0 0"
      hidden={
        !userRolePerms.Modify.includes(component) &&
        !userIsAdmin &&
        data.owner.toLowerCase() !== userEmail.toLowerCase()
      }
      onClick={onClick}
    />
  );
}

export default DeleteButton;
